module.exports = require('./react-handsontable.js').default;



// WEBPACK FOOTER //
// ./src/component/utils/hot-table/index.js